import React from 'react';
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Input, Row, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SelectMultiProductType from "../../../../components/selects/SelectMultiProductType";
import SelectMultiTerritorialUnits from "../../../../components/selects/SelectMultiTerritorialUnits";
import SelectCitizenship from "../../../../components/selects/SelectCitizenship";

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

const operationOptions = [
  { label: "Импорт", value: "IMPORT" },
  { label: "Экспорт", value: "EXPORT" },
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 10 }, (_, index) => currentYear - index);

export const FilterLivestockTradeActivity = (props: IProps) => {
  const { t } = useTranslation();

  return (
	<Form form={ props.form } layout='vertical'>
	  <Row gutter={ [8, 8] }>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Год') }
			name={ props.formField.year }
		  >
			<Select
			  placeholder={ t("msg.selectPlaceholder") }
			  allowClear
			>
			  { years.map((year) => (
				<Select.Option key={ year } value={ year }>
				  { year }
				</Select.Option>
			  )) }
			</Select>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Область') }
			name={ props.formField.citizenshipId }
		  >
			<SelectCitizenship/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Виды продукции') }
			name={ props.formField.productTypeIds }
		  >
			<SelectMultiProductType/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Направление') }
			name={ props.formField.operationType }
		  >
			<Select
			  placeholder={ t("Выберите направление") }
			  options={ operationOptions }
			  allowClear
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Единица измерения') }
			name={ props.formField.unitMeasurementIds }
		  >
			<SelectMultiTerritorialUnits/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Код ТНВЭД') }
			name={ props.formField.hsCode }
		  >
			<Input type='text'/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 24 } md={ 24 } lg={ 24 }>
		  <div style={ { marginTop: 4 } }>
			<Button
			  type="primary"
			  shape="default"
			  icon={ <SearchOutlined/> }
			  style={ { marginRight: 8 } }
			  onClick={ props.onSearch }
			>
			  { t('general.search') }
			</Button>
			<Button
			  type="link"
			  onClick={ props.onReset }
			  style={ { color: "orange" } }
			>
			  { t('general.reset') }
			</Button>
		  </div>
		</Col>
	  </Row>
	</Form>
  );
};
